import { render } from "./LoginRes.vue?vue&type=template&id=076ee6b8"
import script from "./LoginRes.vue?vue&type=script&lang=js"
export * from "./LoginRes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__